import { ScrollArea } from "../components/ScrollArea";
import { Separator } from "../components/Separator";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
const hoveringBarVariants = cva(cn("s-inline-flex s-items-center s-shadow-md s-backdrop-blur-sm s-p-1", "s-bg-background/80 s-border s-border-border dark:s-border-border-night dark:s-bg-background-night/80"), {
    variants: {
        size: {
            xs: "s-rounded-xl",
            sm: "s-rounded-2xl",
        },
    },
    defaultVariants: {
        size: "xs",
    },
});
export function HoveringBar({ children, className, size }) {
    return (React.createElement("div", { className: cn(hoveringBarVariants({ size }), className) },
        React.createElement(ScrollArea, { orientation: "horizontal", hideScrollBar: true, className: "s-h-full" },
            React.createElement("div", { className: "s-flex s-items-center s-gap-1" }, children))));
}
function HoveringBarSeparator() {
    return React.createElement(Separator, { orientation: "vertical", className: "s-my-1" });
}
HoveringBar.Separator = HoveringBarSeparator;
//# sourceMappingURL=HoveringBar.js.map